import React from "react";
import Typewriter from "typewriter-effect";

const Type = () => {
    return (
        <Typewriter
          options={{
            strings: [
              "Full Stack Developer",
              "Passionate ML/DS Enthusiast",
              "Committed Open Source Contributor",
              "Effective Problem Solver",
              "Committed Software Engineer"
            ],
            autoStart: true,
            loop: true,
            deleteSpeed: 50,
          }}
        />
      )
}

export default Type